import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'motion/react';

const STEPS = ['step1', 'step2', 'step3', 'step4'] as const;

export default function How(): JSX.Element {
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  return (
    <section id="how" className="border-rule bg-paper-2 border-b py-24 md:py-32">
      <div className="mx-auto max-w-[1240px] px-6">
        <div className="mb-14 flex flex-wrap items-end justify-between gap-8">
          <div>
            <div className="text-dim mb-[18px] font-mono text-[11px] tracking-[0.22em] uppercase">
              {t('how.eyebrow')}
            </div>
            <h2 className="m-0 max-w-[800px] font-sans text-[clamp(40px,5vw,72px)] leading-none font-semibold tracking-[-0.03em]">
              {t('how.headlineLine1')}
              <br />
              {t('how.headlineLine2')}{' '}
              <span className="text-orange">{t('how.headlineAccent')}</span>
              {t('how.headlineLine3')}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((key, idx) => (
            <motion.div
              key={key}
              initial={reduce ? false : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={reduce ? { duration: 0 } : { duration: 0.5, delay: idx * 0.08 }}
              className="flex flex-col gap-4"
            >
              <div className="text-orange font-mono text-[11px] tracking-[0.22em] uppercase">
                [{t(`how.${key}.num`)}]
              </div>
              <h4 className="m-0 font-sans text-[22px] leading-tight font-semibold tracking-[-0.02em]">
                {t(`how.${key}.title`)}
              </h4>
              <p className="text-dim m-0 text-[14px] leading-[1.55]">{t(`how.${key}.body`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
